import { useRecoilValue } from 'recoil';
import { useAuthSession } from '~/contexts/auth/AuthSessionContext';
import { sessionDataAtom } from '~/state/atoms/sessionAtoms';

/**
 * Display name of the signed-in user: the session's username when a session
 * is open, else the name from the auth session of whichever identity provider
 * is configured; undefined when neither identifies anyone (a deployment
 * without sign-in).
 */
export function useCurrentUserName(): string | undefined {
    const { userName } = useAuthSession();
    const sessionData = useRecoilValue(sessionDataAtom);
    const name = sessionData?.username ?? userName ?? '';
    return name.trim() === '' ? undefined : name;
}
